.container {
  font-size: 1.4rem;
  font-weight: 400;
}

.content {
  display: flex;
  flex-direction: column;
  padding: 1.6rem;
  background-color: var(--color-surface-tertiary);
  border-radius: var(--spacing-radius-md);

  & > span:first-child {
    color: var(--color-grayscale-athens, #e4e6ea);
  }

  & span {
    color: #7a8296;
  }

  h1 {
    font-size: 1.6rem;
    line-height: 2rem;
    font-weight: 400;
    margin-bottom: 0.8rem;
  }

  p {
    line-height: 2rem;
    font-weight: 300;
  }
}

.features-list {
  display: flex;
  flex-direction: column;
  list-style: none;
  gap: 0.8rem;
  margin-top: 0.8rem;
  margin-bottom: 0.8rem;

  span {
    line-height: 2.4rem;
    color: var(--color-grayscale-light-slate, #7a8296);
  }

  li {
    display: flex;
    align-items: center;
    line-height: 2.4rem;
    gap: 0.8rem;
  }
}

.header-with-image {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 15rem;
  width: 100%;
  background-image: url(/images/default-background.png);
  background-position: center;
  background-size: 16rem;
  background-repeat: no-repeat;
  max-width: 100%;

  h3 {
    text-align: center;
    padding-left: 0.8rem;
    padding-right: 0.8rem;
    max-width: 28rem;
    font-size: 1.6rem;
    line-height: 2.4rem;
    font-weight: 500;
    color: var(--color-grayscale-athens, #e4e6ea);
  }
}
